// T047 — Market detail page viewed event definition.

import type { EventDefinition } from './navigation';

export type MarketDetailViewedProperties = {
  marketPubkey: string;
  marketStatus: string;
  hasPositions: boolean;
};

export const MARKET_DETAIL_VIEWED: EventDefinition<MarketDetailViewedProperties> = {
  name: 'market_detail_viewed',
};
